document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vr-sound]').forEach((root) => {
    const playButton = root.querySelector('[data-vr-play]');
    const wave = root.querySelector('[data-vr-wave]');
    const modes = root.querySelectorAll('[data-vr-frequency]');
    let context;
    let oscillator;
    let gain;
    let playing = false;
    let frequency = Number(root.dataset.defaultFrequency || 110);
    let timer;

    const stop = () => {
      if (oscillator) {
        try { oscillator.stop(); } catch (error) { /* already stopped */ }
        oscillator.disconnect();
      }
      if (gain) gain.disconnect();
      clearTimeout(timer);
      oscillator = null;
      gain = null;
      playing = false;
      wave?.classList.remove('is-playing');
      if (playButton) {
        playButton.textContent = 'PLAY';
        playButton.setAttribute('aria-pressed', 'false');
      }
    };

    const play = () => {
      if (playing) return stop();
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;
      context = context || new AudioContextClass();
      oscillator = context.createOscillator();
      gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.value = 0.0001;
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start();
      gain.gain.exponentialRampToValueAtTime(0.03, context.currentTime + 0.2);
      playing = true;
      wave?.classList.add('is-playing');
      playButton.textContent = 'STOP';
      playButton.setAttribute('aria-pressed', 'true');
      timer = window.setTimeout(stop, 6000);
    };

    playButton?.addEventListener('click', play);
    modes.forEach((mode) => mode.addEventListener('click', () => {
      frequency = Number(mode.dataset.vrFrequency);
      modes.forEach((item) => item.classList.remove('is-active'));
      mode.classList.add('is-active');
      if (playing) {
        stop();
        play();
      }
    }));
  });
});
